<template>
    <div>
        <div class="row bg-white sticky-header shadow rounded" style="">
            <div class="col text-left">
                <base-button id="backButton" type="default" @click="backToOverview"></base-button>
            </div>
            <div class="col text-right">
                <base-button type="primary" @click="save" :loading="saving">Save</base-button>
            </div>
        </div>
        <h2 v-show="isLoading">We're loading in all the data...
            <font-awesome-icon :icon="['fal','spinner-third']" spin></font-awesome-icon>
        </h2>
        <ul id="timeline" class="timeline ui-sortable">
            <li v-for="flow in flows" :key="flow.order" class="ui-sortable-handle dont-drag">
                <div class="timeline-item" style="margin-left:80px;">
                    <div class="timeline-body">
                        <card>
                            <div class="row-fluid">
                                <timecondition-selector :initial-timecondition="flow.timecondition"
                                                        v-on:update="handleTimeconditionUpdate(flow.order, $event)"/>
                                <hr>
                                <destination-selector class="mt-3" v-for="destination in flow.destinations"
                                                      :initial-destination="destination"
                                                      :key="flow.order + '-' + destination.order"
                                                      v-on:remove="deleteDestination(flow,destination)"
                                                      v-on:update="updateDestination(flow,$event)">
                                </destination-selector>
                                <el-tooltip content="Add another destination to this flow."
                                            effect="dark"
                                            :open-delay="300"
                                            placement="top">
                                    <base-button @click="addDestination(flow)">Add Destination</base-button>
                                </el-tooltip>
                                <div class="btn-group right">
                                    <el-tooltip content="Move this flow down in the order."
                                                effect="dark"
                                                :open-delay="300"
                                                placement="top">
                                        <base-button type="primary" @click="moveFlowUp(flow)">
                                            <font-awesome-icon :icon="['fal','chevron-up']"></font-awesome-icon>
                                        </base-button>
                                    </el-tooltip>
                                    <el-tooltip content="Move this flow up in the order."
                                                effect="dark"
                                                :open-delay="300"
                                                placement="top">
                                        <base-button type="primary" @click="moveFlowDown(flow)">
                                            <font-awesome-icon :icon="['fal','chevron-down']"></font-awesome-icon>
                                        </base-button>
                                    </el-tooltip>
                                    <el-tooltip content="This will remove this flow from the range of flows."
                                                effect="dark"
                                                :open-delay="300"
                                                placement="top">
                                        <base-button type="danger" @click="deleteFlow(flow)">Remove Flow</base-button>
                                    </el-tooltip>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </li>
            <li class="ui-sortable-handle dont-drag">
                <div class="timeline-item " style="margin-left:80px;">
                    <div class="timeline-body">
                        <card>
                            <base-button @click="addFlow">Add flow</base-button>
                        </card>
                    </div>
                </div>
            </li>
            <!-- END timeline item -->
        </ul>

    </div>

</template>

<script>
import DestinationSelector from "../../components/Destinations/DestinationSelector";
import TimeconditionSelector from "../../components/TimeconditionSelector";

export default {
    name: "CallFlow",
    components: {
        TimeconditionSelector,
        DestinationSelector,
    },
    props: {
        show: Boolean,
    },
    data() {
        return {
            saving: false,
            drag: false,
            ringgroup: null,
            defaultFlow: {
                timecondition: null,
                order: 1,
                destinations: [
                    {
                        type: 'default',
                        ringgroup: null,
                        devices: [],
                        numbers: ['+99'],
                        timeout: 30,
                        ivr: null,
                        queue: null,
                        voicemail: null,
                        order: 1,
                    }
                ]
            },
            defaultDestination: {
                type: 'default',
                ringgroup: null,
                devices: [],
                numbers: ['+99'],
                timeout: 30,
                ivr: null,
                queue: null,
                voicemail: null,
                order: 1,
            },
            flows: [{
                order: 1,
                timecondition: null,
                destinations: [
                    {
                        type: 'default',
                        ringgroup: null,
                        devices: [],
                        numbers: ['+99'],
                        timeout: 30,
                        ivr: null,
                        queue: null,
                        voicemail: null,
                        order: 1,
                    }
                ]
            }],
            number: this.$route.params.did,
            ivr: this.$route.params.ivr,
            button: this.$route.params.button,
        }
    },
    computed: {
        callflows() {
            return this.$store.getters['callflow/callflows'];
        },
        isLoading() {
            return this.$store.getters['callflow/isLoading'];
        },
        ivrs() {
            return this.$store.getters['ivr/ivrs'];
        },
        internal() {
            return this.$store.getters['ivr/internal'];
        },
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName)
        },
        validate() {
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    this.updateSettings()
                }
            })
        },
        addFlow() {
            let flow = JSON.parse(JSON.stringify(this.defaultFlow));
            flow.did = this.number;
            let highestOrder = Math.max(...this.flows.map(f => parseInt(f.order)));
            if (isFinite(highestOrder) === false) {
                highestOrder = 0;
            }
            flow.order = highestOrder + 1;
            this.flows.push(flow);
        },
        deleteFlow(flow) {
            this.flows = this.flows.filter(f => parseInt(f.order) !== parseInt(flow.order));
            this.reorderFlows();
        },
        reorderFlows() {
            if (this.flows.length <= 1) {
                return;
            }
            this.flows = this.flows.sort((a, b) => (parseInt(a.order) > parseInt(b.order)) ? 1 : ((parseInt(b.order) > parseInt(a.order)) ? -1 : 0));

            let counter = 1;
            this.flows = this.flows.map(f => {
                f.order = counter;
                counter++;
                return f;
            })
        },
        moveFlowDown(flow) {
            let oldOrder = JSON.parse(JSON.stringify(flow.order));
            let lesserFlows = this.flows.filter(f => parseInt(f.order) > oldOrder);
            if (lesserFlows.length === 0) {
                return;
            }

            flow.order = oldOrder + 1;
            lesserFlows[0].order = lesserFlows[0].order - 1;

            this.reorderFlows();
        },
        moveFlowUp(flow) {
            let oldOrder = JSON.parse(JSON.stringify(flow.order));
            let betterFlows = this.flows.filter(f => parseInt(f.order) < oldOrder);

            if (betterFlows.length === 0) {
                return;
            }

            flow.order = oldOrder - 1;
            betterFlows[0].order = betterFlows[0].order + 1;

            this.reorderFlows();
        },
        addDestination(flow) {
            let highestOrder = Math.max(...flow.destinations.map(d => parseInt(d.order)));
            let extraDestination = JSON.parse(JSON.stringify(this.defaultDestination));
            if (isFinite(highestOrder) === false) {
                highestOrder = 0;
            }
            extraDestination.order = highestOrder + 1;
            this.flows.filter(f => f == flow)[0].destinations.push(extraDestination);
        },
        deleteDestination(flow, destination) {
            flow.destinations = flow.destinations.filter(d => parseInt(d.order) !== parseInt(destination.order));
            this.reorderDestinations(flow);
        },
        updateDestination(flow, destination) {
            let dest = flow.destinations.filter(d => parseInt(d.order) !== parseInt(destination.order));
            dest = destination;
        },
        reorderDestinations(flow) {
            flow.destinations = flow.destinations.sort((a, b) => parseInt(a.order) > parseInt(b.order) ? parseInt(a.order) : parseInt(b.order));
            let counter = 1;
            flow.destinations = flow.destinations.map(d => {
                d.order = counter;
                counter++;
                return d;
            })
        },
        handleTimeconditionUpdate(order, timecondition) {
            this.flows.find(f => parseInt(f.order) === parseInt(order)).timecondition = timecondition.id;
        },
        handleTimeconditionClear(order) {
            this.flows.find(f => parseInt(f.order) === parseInt(order)).timecondition = null;
        },
        initializeCallflow() {
            if (this.ivr && this.button && this.ivr.endsWith('_TRF')) {
                this.$store.dispatch('ivr/loadInternal').then(() => {
                    this.setInternalFlows();
                    this.setDefaultDestinationToFirstFlow();
                })
            }

            if (this.ivr && this.button && this.ivr.endsWith('_TRF') === false) {
                if (this.$store.getters['ivr/needUpdate']) {
                    this.$store.dispatch('ivr/load').then(() => {
                        this.setIVRFlows();
                        this.setDefaultDestinationToFirstFlow();
                    });
                } else {
                    this.setIVRFlows();
                }
            }

            this.setDefaultDestinationToFirstFlow();

            if (this.number) {
                if (this.$store.getters['did/needUpdate']) {
                    this.$store.dispatch('did/loadUniqueDIDs');
                }

                if (this.$store.getters['callflow/needUpdate']) {
                    this.$store.dispatch('callflow/loadAll').then(() => {
                        this.setDIDFlows();
                    });
                } else {
                    this.setDIDFlows();
                }
            }

            this.reorderFlows();
        },
        setInternalFlows() {
            this.$set(this, 'flows', JSON.parse(JSON.stringify(this.internal.buttons[this.button])))

        },
        setIVRFlows() {
            this.$set(this, 'flows', JSON.parse(JSON.stringify(this.ivrs.filter(i => i.id === this.ivr)[0].buttons[this.button])));
        },
        setDIDFlows() {
            this.$set(this, 'flows', JSON.parse(JSON.stringify(this.callflows.filter(f => f.did === this.number))));
            this.reorderFlows();
        },
        setDefaultDestinationToFirstFlow() {
            if (this.flows[0].destinations.length === 0) {
                let extraDestination = JSON.parse(JSON.stringify(this.defaultDestination));
                this.flows[0].destinations.push(extraDestination);
            }
        },
        save() {
            let callflow = this.flows;
            this.saving = true;
            if (this.ivr && this.button) {
                let button = this.button;
                let ivr = this.ivr;
                this.$store.dispatch('ivr/save', {ivr, button, callflow}).then(() => {
                    this.backToOverview();
                }).catch(() => {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Your callflow: ' + data.name + ' failed to save!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                }).finally(() => {
                    this.saving = false;
                });
            } else {
                let did = this.number;

                this.$store.dispatch('callflow/save', {did, callflow}).then(() => {
                    this.$notify({
                        verticalAlign: 'bottom',
                        horizontalAlign: 'right',
                        message: 'Your callflow  was saved!',
                        type: "success",
                        icon: "fal fa-save",
                        title: "Saved!"
                    });
                    this.backToOverview();
                }).catch(() => {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Your callflow failed to save!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });
                }).finally(() => {
                    this.saving = false;
                });
            }
        },
        backToOverview() {

            if (this.ivr && this.button && this.ivr.endsWith('_TRF')) {
                this.$router.push('/internal');
                return;
            }

            if (this.ivr && this.button) {
                this.$router.push('/ivrs');
                return;
            }

            if (this.number) {
                this.$router.push('/numbers');
            }
        }
    },
    mounted() {
        this.initializeCallflow();
    },
    watch: {},
}
</script>

<style scoped>

.sticky-header {
    z-index: 2;
    position: sticky;
    top: 0;
    margin-bottom: 2em;
    padding: 1em;
}

#backButton:before {
    content: 'Back to overview'
}

@media (max-width: 767.98px) {
    .sticky-header {
        margin-left: 7.5px;
        margin-right: 7.5px;
    }

    #backButton:before {
        content: 'Overview'
    }
}

.timeline li:not(.ui-sortable-helper):before {
    transition: border-width 0.6s linear;
}

.timeline li.being-dragged:not(.ui-sortable-helper):before {
    border: 35px solid white;
    color: #e14eca;
}

.timeline {
    position: relative;
    padding: 0;
    list-style: none;
    counter-reset: section;
}

.timeline:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #e14eca;
    left: 32px;
    margin: 0;
    border-radius: 2px;
}

.timeline > li {
    position: relative;
    margin-right: 10px;
    margin-bottom: 50px;
    padding-top: 18px;
    box-sizing: border-box;
}

.timeline > li:before,
.timeline > li:after {
    display: block;
}

.ui-sortable-helper .handle {
    display: none;
}

.timeline > li:not(.ui-sortable-helper):before {
    counter-increment: section;
    content: counter(section);
    background: #e14eca;
    width: 70px;
    height: 70px;
    position: absolute;
    top: 0;
    border-radius: 50%;
    left: -1px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #Fff;
    font-size: 22px;
    font-weight: bold;
    border: 15px solid #fff;
    box-sizing: border-box;
}

.timeline > li:after {
    clear: both;
}

.timeline > li > .timeline-item {
    margin-top: 0;
    color: #444;
    margin-left: 60px;
    margin-right: 15px;
    padding: 0;
}

.timeline > li > .fa,
.timeline > li > .glyphicon,
.timeline > li > .ion {
    width: 30px;
    height: 30px;
    font-size: 15px;
    line-height: 30px;
    position: absolute;
    color: #fff;
    background: #e14eca;
    border-radius: 50%;
    text-align: center;
    left: 18px;
    top: 0;
}

.radio-thumbnail > label {
    border-radius: 4px;
}

.radio-thumbnail > input {
    display: none;
}

.radio-thumbnail > :checked + .thumbnail {
    border: 4px solid #21BB05;
    border-radius: 4px;
}

.radio-thumbnail > :checked + .thumbnail > span {
    border-radius: 0;
}

.radio-thumbnail > :disabled + .thumbnail {
    opacity: .5;
}

.radio-thumbnail > :checked + .thumbnail:before {
    content: "\f00c";
    font-family: fontawesome;
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 15px;
    z-index: 1;
    color: #fff;
    background: #21bb05;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s all;
}


.thumbnail > span {
    position: absolute;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,0.65+100 */
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
    /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
    /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
    /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#a6000000', GradientType=0);
    /* IE6-9 */
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    padding: 97px 0 0 16px;
    text-align: left;
    border-radius: 4px;
    border: 0;
}

.uxc__f-tags .btn.btn-default {
    border-color: #e14eca;
    background: transparent;
    color: #e14eca;
}

.uxc__f-tags .btn {
    margin-right: 15px;
}

.uxc__f-tags .btn.btn-default:hover,
.uxc__f-tags .btn.btn-default:focus,
.uxc__f-tags .btn.btn-default:active,
.uxc__f-tags .btn.btn-default.active {
    border-color: #e14eca;
    background: #e14eca;
    color: #fff;
    box-shadow: 0px 0px 0px;
    transition: all 0.3s;
}


.add-n-f i {
    border: 1px dotted #989898;
    width: 25px;
    height: 25px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
}

.add-n-f:hover i {
    color: #e14eca;
    border-color: #e14eca;
}

#sortable li {
    margin: 0 3px 3px 3px;
    padding: 0.4em;
    padding-left: 1.5em;
    font-size: 1.4em;
    height: 18px;
}

#sortable li span {
    position: absolute;
    margin-left: -1.3em;
}
</style>
